import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { CONTROL_ACTIONMODE, FREETEXT_ITEMCODE, ITEM_MODE_KEY, WALLPINTEXT_Z } from '../Constants';
import { Stage } from '../model';
import { compose } from 'underscore';
/**
 * テキストアイテムのアイテムコントローラー
 */
export default class ItemControllerFreeCharacterInput {
  mousePlace: marietta.core.Point;

  floor: number;

  callbackOnComplete: Function;

  callbackOnInterrupt: Function;

  tarLayer: marietta.webcad.layer.FloorLayer;

  public spt: SVGSprite;

  lastTime: number;

  tarDialog: marietta.webcad.view.dialog.core.view.Dialog;

  textAttribute: any;

  isPinText: boolean;

  btnDelete: marietta.webcad.control.parts.ButtonGarbage;

  btnTextSetting: marietta.webcad.control.parts.ButtonTextSetting;

  btnDragger: marietta.webcad.control.parts.DraggerMobile;
  /**
   * コンストラクタ
   */
  constructor(isPin) {
    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor) as marietta.webcad.layer.FloorLayer;
    // テキスト入力ダイアログの作成
    this.isPinText = isPin;
    const param = { isPinText: this.isPinText };
    this.tarDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.FreeCharacterInputDialog, false, false, false, false, param);
    // 入力ダイアログからのコールバック関数
    this.tarDialog.callBack = this.createText;
  }

  /**
   * mouseイベント（ipad,mobileのみ）
   * クリックポイント取得
   */
  getClickPoint = (e: TouchEvent) => {
    Stage.refreshStageMouse(<any>e);
    e.preventDefault();
  }

  /**
   * mouseUpイベント
   */
  onMouseUp = (e: MouseEvent & TouchEvent) => {
    e.stopPropagation();
    const wheelclick = e.which ? e.which === 2 : e.button === 2;
    if (wheelclick) {
      return;
    }
    if ('which' in e && e.which === 3) {
      this.clean();
      return;
    }
    // グリッドレイヤーのクリックポイントの座標
    this.mousePlace = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_FREE_CHARACTER ||
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_PIN_TEXT ||
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_PIN_PANORAMA) {
      this.createItem();
    } else {
      this.clean();
    }
  }

  /**
   * イベントを削除し、アイテムの作成をクリーンアップします
   */
  clean() {
    const stage = document.querySelector('#layerGroup');
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.removeEventListener('touchstart', this.getClickPoint);
      stage.removeEventListener('touchmove', this.getClickPoint);
      stage.removeEventListener('touchend', this.onMouseUp);
    } else {
      stage.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  /**
   * 入力の中断
   */
  interrupt() {
    this.clean();
  }

  /**
   * 入力ダイアログからのコールバック関数
   * @param text
   */
  createText = (textAttribute) => {
    this.textAttribute = textAttribute;
    const stage = document.querySelector('#layerGroup');
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.addEventListener('touchstart', this.getClickPoint, { passive: false });
      stage.addEventListener('touchmove', this.getClickPoint, { passive: false });
      stage.addEventListener('touchend', this.onMouseUp, { passive: false });
    } else {
      stage.addEventListener('mouseup', this.onMouseUp);
    }
  }

  /**
   * テキストアイテムの作成
   */
  createItem = () => {
    const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
    if (this.isPinText) {
      info.id = marietta.webcad.WebCADGlobal.getPinTextId(this.textAttribute.text_category);
    } else {
      info.id = `${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${FREETEXT_ITEMCODE}`;
    }

    info.guid = marietta.webcad.WebCADGlobal.getGuid();
    info.x = this.mousePlace.x;
    info.y = this.mousePlace.y;
    info.text_color = this.textAttribute.text_color;
    info.font_size = this.textAttribute.font_size;
    info.is_bold = this.textAttribute.is_bold;
    info.is_italic = this.textAttribute.is_italic;
    info.is_underline = this.textAttribute.is_underline;
    info.is_strike_through = this.textAttribute.is_strike_through;
    info.text_alignment = this.textAttribute.text_alignment;
    info.text = this.textAttribute.text;
    if (this.textAttribute.link) {
      info.link = this.textAttribute.link;
    }
    const textSize = marietta.webcad.util.TextUtil.getTextSizeWh(this.textAttribute.text, marietta.webcad.WebCADGlobal.freeTextFontFamily, marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size);
    info.width = textSize.width;
    info.height = textSize.height;
    if (!marietta.webcad.WebCADGlobal.isWallPinText(info.id)) {
      info.z = 0;
    } else {
      const heightData = marietta.webcad.WebCADGlobal.itemManager.getFloorAndCeilingHeight();
      const fl = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor === 1 ? heightData.fl1 : marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor === 2 ? heightData.fl2 : heightData.fl3;
      info.z = fl + WALLPINTEXT_Z;
    }
    marietta.webcad.WebCADGlobal.itemManager.createItem(info);
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    this.clean();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    if (this.isPinText) {
      (<HTMLInputElement>document.getElementById('btnPinTextInput')).checked = false;
    } else {
      (<HTMLInputElement>document.getElementById('btnTextInput')).checked = false;
    }
  }
}
